module.exports = __webpack_public_path__ + "img/dinning-table-fill-color.4bfc3a66.svg";